import { render } from "./ImgBorderBox.vue?vue&type=template&id=d62b8b52&scoped=true"
import script from "./ImgBorderBox.vue?vue&type=script&lang=js"
export * from "./ImgBorderBox.vue?vue&type=script&lang=js"

import "./ImgBorderBox.vue?vue&type=style&index=0&id=d62b8b52&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d62b8b52"]])

export default __exports__